/*! @pentacode/ui v0.1.0 */
import { t as e } from "./reduced-motion-CZnc3mB7.js";
import { t } from "./styledElement-DUAqv8gi.js";
import { t as n } from "./css-build-DcREbovZ.js";
import { t as r } from "./decorateMetadata-BXz2gmG4.js";
import { t as i } from "./decorate-C_HUHFGG.js";
import { LitElement as a, html as o } from "lit";
import { customElement as s, property as c, query as l } from "lit/decorators.js";
// \0lit-plugin:css-sheet:./src/elements/assistant/assistant-spinner/assistant-spinner.css.js
var u = n(":host{display:block}canvas{height:var(--assistant-spinner-height,4rem);aspect-ratio:1;width:auto;display:block}"), d = 256, f = 75, p = 1.05, m = -.35, h = .25, g = d / 2, _ = d / 2;
function v(e) {
	let t = e.replace("#", "");
	return [
		parseInt(t.slice(0, 2), 16) || 0,
		parseInt(t.slice(2, 4), 16) || 0,
		parseInt(t.slice(4, 6), 16) || 0
	];
}
function y(e, t) {
	return [
		Math.max(0, Math.min(255, e[0] + t)),
		Math.max(0, Math.min(255, e[1] + t)),
		Math.max(0, Math.min(255, e[2] + t))
	];
}
function b(e) {
	return [
		y(e, -45),
		y(e, -25),
		e,
		y(e, 15),
		y(e, 25)
	];
}
function x(e) {
	return [
		e,
		y(e, -20),
		y(e, 15),
		y(e, -10)
	];
}
function S(e) {
	return [
		e,
		y(e, -16),
		y(e, -6),
		y(e, 4),
		y(e, -26)
	];
}
function C(e) {
	let t = e * h, n = Math.cos(p), r = Math.sin(p), i = Math.cos(m), a = Math.sin(m), o = Math.cos(t), s = Math.sin(t);
	return function(e, t, c, l) {
		let u = e * o + c * s, d = -e * s + c * o, f = t * n - d * r, p = t * r + d * n, m = u * i - f * a, h = u * a + f * i, v = 300 / (300 + p);
		return {
			x: g + m * v,
			y: _ + l + h * v,
			z: p,
			scale: v
		};
	};
}
var w;
function T(e, t, n, r) {
	return w(Math.cos(e) * t, r, Math.sin(e) * t, n);
}
function E(e, t, n, r, i) {
	let a = Math.cos(e) * t, o = Math.sin(e) * t, s = r, c = Math.cos(i), l = Math.sin(i), u = s * c - o * l, d = s * l + o * c;
	return w(a, u, d, n);
}
function D(e, t) {
	let n = Math.sin(e * 127.1 + t * 311.7) * 43758.5453;
	return n - Math.floor(n);
}
function O(e, t) {
	let n = Math.floor(e), r = e - n, i = r * r * (3 - 2 * r);
	return D(n, t) * (1 - i) + D(n + 1, t) * i;
}
var k = class {
	constructor(e, t, n, r, i) {
		this._radius = e.radius, this._peaks = e.peaks, this._amp = e.amp, this._speed = e.speed, this._rotSpeed = e.rotSpeed, this._yOffset = e.yOffset, this._width = e.width * i, this._blur = e.blur * i, this._phase = e.phase, this._fadeSpeed = e.fadeSpeed, this._seed = e.seed, this._greenSplash = e.greenSplash, this._orbitTilt = e.orbitTilt, this.color = n, this.accentColor = r, this._pad = Math.ceil(this._blur * 3), this._offW = d + this._pad * 2, this._offH = d + this._pad * 2, this._offCanvas = document.createElement("canvas"), this._offCanvas.width = this._offW * t, this._offCanvas.height = this._offH * t, this._offCtx = this._offCanvas.getContext("2d"), this._offCtx.setTransform(t, 0, 0, t, 0, 0);
	}
	render(e) {
		let t = e * this._speed + this._phase, n = e * this._rotSpeed, r = Math.PI * 2 / 180, i = this._offCtx;
		i.clearRect(0, 0, this._offW, this._offH), i.save(), i.filter = `blur(${this._blur}px)`, i.lineWidth = this._width, i.lineCap = "round", i.lineJoin = "round";
		let a = .4 + .6 * Math.abs(Math.sin(e * this._fadeSpeed)), [o, s, c] = this.color;
		i.translate(this._pad, this._pad);
		let l = .6 + .4 * Math.sin(e * .4 + this._seed) + Math.max(0, Math.sin(e * 1.7 + this._seed * 3)) ** 4 * .6;
		for (let u = 0; u < 2; u++) {
			i.beginPath();
			let d = !1;
			for (let a = 0; a <= 180; a++) {
				let o = a * r, s = o + n, c = Math.round(s * this._peaks / (Math.PI * 2) % this._peaks), f = .3 + O(e * .8 + c * 7.3, this._seed + c) * 1.4, p = Math.abs(Math.sin(s * this._peaks / 2 + t)) ** 1.5, m = -(this._amp * p * l * f + Math.sin(s * 37 + t * 4) * this._amp * .04 * l), h = this._orbitTilt === 0 ? T(o, this._radius, this._yOffset, m) : E(o, this._radius, this._yOffset, m, this._orbitTilt), g = h.z > 0;
				u === 0 && !g || u === 1 && g ? d = !1 : d ? i.lineTo(h.x, h.y) : (i.moveTo(h.x, h.y), d = !0);
			}
			i.strokeStyle = `rgba(${o},${s},${c},${u === 0 ? .25 * a : .9 * a})`, i.stroke();
		}
		if (this._greenSplash) {
			let o = Math.max(0, Math.sin(e * 1.3 + this._seed * 2)) ** 2, s = Math.max(0, Math.sin(e * .9 + this._seed * 5 + 1.5)) ** 2, c = Math.max(o, s);
			if (c > .03) {
				i.beginPath();
				let o = !1;
				for (let a = 0; a <= 180; a++) {
					let s = a * r, c = s + n, u = Math.abs(Math.sin(c * this._peaks / 2 + t)) ** 1.5;
					if (u < .25) {
						o = !1;
						continue;
					}
					let d = Math.round(c * this._peaks / (Math.PI * 2) % this._peaks), f = .3 + O(e * .8 + d * 7.3, this._seed + d) * 1.4, p = -(this._amp * u * l * f), m = this._orbitTilt === 0 ? T(s, this._radius, this._yOffset, p) : E(s, this._radius, this._yOffset, p, this._orbitTilt);
					m.z > 0 ? o = !1 : o ? i.lineTo(m.x, m.y) : (i.moveTo(m.x, m.y), o = !0);
				}
				let [s, u, d] = this.accentColor;
				i.strokeStyle = `rgba(${s},${u},${d},${c * .85 * a})`, i.lineWidth = this._width * .7, i.stroke();
			}
		}
		i.restore();
	}
	stamp(e) {
		e.drawImage(this._offCanvas, 0, 0, this._offCanvas.width, this._offCanvas.height, -this._pad, -this._pad, this._offW, this._offH);
	}
}, A = class {
	constructor(e, t, n) {
		this._radius = e.radius, this._orbitSpeed = e.orbitSpeed, this._bobSpeed = e.bobSpeed, this._bobAmp = e.bobAmp, this._driftRadius = e.driftRadius, this._size = e.size, this._fadeSpeed = e.fadeSpeed, this._angle = e.startAngle, this._yOffset = e.yOffset, this._seed = e.seed, this.colorIndex = e.colorIndex, this.isPrimary = e.isPrimary, this.color = t, this.thickness = n;
	}
	draw(e, t) {
		let n = this._angle + t * this._orbitSpeed, r = Math.sin(t * .6 + this._seed * 5) * this._driftRadius, i = this._radius + r, a = Math.sin(t * this._bobSpeed + this._seed * 3) * this._bobAmp, o = T(n, i, this._yOffset, a), s = (o.z > 0 ? .2 : 1) * (.3 + .7 * (.5 + .5 * Math.sin(t * this._fadeSpeed + this._seed))), c = this._size * this.thickness * (.7 + .3 * Math.sin(t * 2.5 + this._seed * 7)) * o.scale, [l, u, d] = this.color;
		e.save(), e.shadowColor = `rgba(${l},${u},${d},${s * .8})`, e.shadowBlur = c * 4, e.beginPath(), e.arc(o.x, o.y, Math.max(.3, c), 0, Math.PI * 2), e.fillStyle = `rgba(${l},${u},${d},${s})`, e.fill(), e.restore();
	}
}, j = [
	{
		radius: f * 1.08,
		peaks: 5,
		amp: 12,
		speed: .6,
		rotSpeed: .08,
		yOffset: -8,
		width: 10,
		blur: 10,
		phase: 0,
		fadeSpeed: .15,
		seed: 1,
		greenSplash: !0,
		orbitTilt: 0
	},
	{
		radius: f * 1.04,
		peaks: 5,
		amp: 14,
		speed: .8,
		rotSpeed: .12,
		yOffset: -8,
		width: 6,
		blur: 6,
		phase: .5,
		fadeSpeed: .2,
		seed: 2,
		greenSplash: !0,
		orbitTilt: 0
	},
	{
		radius: f,
		peaks: 5,
		amp: 16,
		speed: 1,
		rotSpeed: .15,
		yOffset: -8,
		width: 3.5,
		blur: 3,
		phase: 0,
		fadeSpeed: .3,
		seed: 3,
		greenSplash: !0,
		orbitTilt: 0
	},
	{
		radius: f * .96,
		peaks: 5,
		amp: 13,
		speed: 1.3,
		rotSpeed: -.1,
		yOffset: -8,
		width: 2.5,
		blur: 1.5,
		phase: 1.2,
		fadeSpeed: .35,
		seed: 4,
		greenSplash: !0,
		orbitTilt: 0
	},
	{
		radius: f * .99,
		peaks: 5,
		amp: 15,
		speed: 1.05,
		rotSpeed: .14,
		yOffset: -8,
		width: 2,
		blur: 1,
		phase: .2,
		fadeSpeed: .28,
		seed: 5,
		greenSplash: !0,
		orbitTilt: 0
	}
], M = [
	{
		radius: f * 1.04,
		peaks: 5,
		amp: 14,
		speed: .8,
		rotSpeed: .12,
		yOffset: -8,
		width: 4,
		blur: 4,
		phase: 0,
		fadeSpeed: .2,
		seed: 1,
		greenSplash: !0,
		orbitTilt: 0
	},
	{
		radius: f * 1.04,
		peaks: 5,
		amp: 14,
		speed: .8,
		rotSpeed: .12,
		yOffset: -8,
		width: 4,
		blur: 4,
		phase: .5,
		fadeSpeed: .2,
		seed: 2,
		greenSplash: !0,
		orbitTilt: Math.PI * 2 / 3
	},
	{
		radius: f * 1.04,
		peaks: 5,
		amp: 14,
		speed: .8,
		rotSpeed: .12,
		yOffset: -8,
		width: 4,
		blur: 4,
		phase: 1,
		fadeSpeed: .2,
		seed: 3,
		greenSplash: !0,
		orbitTilt: -(Math.PI * 2) / 3
	}
];
function N(e) {
	return () => {
		e = e + 1831565813 | 0;
		let t = Math.imul(e ^ e >>> 15, 1 | e);
		return t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t, ((t ^ t >>> 14) >>> 0) / 4294967296;
	};
}
function P() {
	let e = [], t = N(1);
	for (let n = 0; n < 8; n++) e.push({
		radius: f * (.85 + t() * .35),
		orbitSpeed: (.15 + t() * .25) * (t() > .5 ? 1 : -1),
		bobSpeed: 1 + t() * 2,
		bobAmp: 3 + t() * 10,
		driftRadius: 5 + t() * 12,
		size: 1.2 + t() * 2,
		colorIndex: n % 4,
		isPrimary: !0,
		fadeSpeed: .4 + t() * .8,
		startAngle: n / 8 * Math.PI * 2 + t() * .5,
		yOffset: -8,
		seed: n * 3.7
	});
	for (let n = 0; n < 14; n++) e.push({
		radius: f * (.82 + t() * .4),
		orbitSpeed: (.1 + t() * .35) * (t() > .5 ? 1 : -1),
		bobSpeed: 1 + t() * 2.5,
		bobAmp: 3 + t() * 14,
		driftRadius: 4 + t() * 12,
		size: 1 + t() * 2.2,
		colorIndex: n % 5,
		isPrimary: !1,
		fadeSpeed: .4 + t() * 1,
		startAngle: n / 14 * Math.PI * 2 + t() * .8,
		yOffset: -8,
		seed: 200 + n * 4.1
	});
	for (let n = 0; n < 6; n++) {
		let r = n % 2 == 0;
		e.push({
			radius: f * (1.25 + t() * .3),
			orbitSpeed: (.05 + t() * .12) * (t() > .5 ? 1 : -1),
			bobSpeed: .5 + t(),
			bobAmp: 2 + t() * 6,
			driftRadius: 8 + t() * 15,
			size: .8 + t() * 1.2,
			colorIndex: 0,
			isPrimary: !r,
			fadeSpeed: .2 + t() * .4,
			startAngle: n / 6 * Math.PI * 2 + t(),
			yOffset: -8,
			seed: 50 + n * 5.3
		});
	}
	for (let n = 0; n < 10; n++) {
		let r = n % 2 == 0;
		e.push({
			radius: f * (.92 + t() * .16),
			orbitSpeed: (.4 + t() * .5) * (t() > .5 ? 1 : -1),
			bobSpeed: 3 + t() * 3,
			bobAmp: 1 + t() * 4,
			driftRadius: 2 + t() * 6,
			size: .5 + t() * .8,
			colorIndex: r ? 0 : 2,
			isPrimary: !r,
			fadeSpeed: 1 + t() * 1.5,
			startAngle: t() * Math.PI * 2,
			yOffset: -8,
			seed: 100 + n * 2.1
		});
	}
	return e;
}
var F = P(), I = class extends t(a) {
	constructor(...t) {
		super(...t), this.styles = u, this.speed = 2, this.primaryColor = "#c3e7f5", this.accentColor = "#e2ff41", this.thickness = 2, this.atomOrbit = !1, this.paused = !1, this._animationId = null, this._rings = [], this._particles = [], this._initialized = !1, this._reducedMotion = new e(this), this._still = this._reducedMotion.matches;
	}
	render() {
		return o`<canvas part="canvas"></canvas>`;
	}
	firstUpdated() {
		this._activate();
	}
	updated(e) {
		this._still !== this._reducedMotion.matches && (this._still = this._reducedMotion.matches, this._stopAnimation(), this._activate()), e.has("paused") && (this.paused ? this._stopAnimation() : this._activate()), this._initialized && (e.has("thickness") || e.has("atomOrbit") ? (this._rebuildObjects(), this._startAnimation()) : (e.has("primaryColor") || e.has("accentColor")) && (this._applyColors(), this._startAnimation()));
	}
	connectedCallback() {
		super.connectedCallback(), this._handleVisibilityChange = this._handleVisibilityChange.bind(this), document.addEventListener("visibilitychange", this._handleVisibilityChange);
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this._animationId !== null && (cancelAnimationFrame(this._animationId), this._animationId = null), document.removeEventListener("visibilitychange", this._handleVisibilityChange);
	}
	_handleVisibilityChange() {
		document.hidden ? this._stopAnimation() : this._activate();
	}
	_activate() {
		this.paused || (this._initialized ||= (this._setupCanvas(), !0), this._startAnimation());
	}
	_applyColors() {
		let e = v(this.primaryColor), t = v(this.accentColor), n = b(e);
		for (let e = 0; e < this._rings.length; e++) {
			let r = this._rings[e], i = n[e];
			r && i && (r.color = i, r.accentColor = t);
		}
		let r = x(e), i = S(t);
		for (let e of this._particles) if (e.isPrimary) {
			let t = r[e.colorIndex % r.length];
			t && (e.color = t);
		} else {
			let t = i[e.colorIndex % i.length];
			t && (e.color = t);
		}
	}
	_rebuildObjects() {
		if (!this._canvas) return;
		let e = window.devicePixelRatio || 1, t = v(this.primaryColor), n = v(this.accentColor), r = b(t), i = x(t), a = S(n), o = this.atomOrbit ? M : j;
		this._rings = o.map((t, i) => {
			let a = r[i % r.length];
			if (!a) throw Error(`Missing ring color at index ${i}`);
			return new k(t, e, a, n, this.thickness);
		}), this._particles = F.map((e) => {
			let t = e.isPrimary ? i : a, n = t[e.colorIndex % t.length];
			if (!n) throw Error(`Missing particle color at index ${e.colorIndex}`);
			return new A(e, n, this.thickness);
		});
	}
	_setupCanvas() {
		let e = this._canvas;
		if (!e) return;
		let t = window.devicePixelRatio || 1;
		e.width = d * t, e.height = d * t;
		let n = e.getContext("2d");
		n && n.setTransform(t, 0, 0, t, 0, 0);
		let r = v(this.primaryColor), i = v(this.accentColor), a = b(r), o = x(r), s = S(i), c = this.atomOrbit ? M : j;
		this._rings = c.map((e, n) => {
			let r = a[n % a.length];
			if (!r) throw Error(`Missing ring color at index ${n}`);
			return new k(e, t, r, i, this.thickness);
		}), this._particles = F.map((e) => {
			let t = e.isPrimary ? o : s, n = t[e.colorIndex % t.length];
			if (!n) throw Error(`Missing particle color at index ${e.colorIndex}`);
			return new A(e, n, this.thickness);
		});
	}
	_startAnimation() {
		if (this.paused || this._animationId !== null) return;
		let e = this._canvas;
		if (!e) return;
		let t = e.getContext("2d");
		if (!t) return;
		let n = window.devicePixelRatio || 1, r = this._still, i = (e) => {
			let a = (r ? 0 : e * .001) * this.speed;
			w = C(a), t.setTransform(n, 0, 0, n, 0, 0), t.clearRect(0, 0, d, d);
			for (let e of this._rings) e.render(a), e.stamp(t);
			for (let e of this._particles) e.draw(t, a);
			this._animationId = r ? null : requestAnimationFrame(i);
		};
		this._animationId = requestAnimationFrame(i);
	}
	_stopAnimation() {
		this._animationId !== null && (cancelAnimationFrame(this._animationId), this._animationId = null);
	}
};
i([c({ type: Number }), r("design:type", Object)], I.prototype, "speed", void 0), i([c({ type: String }), r("design:type", Object)], I.prototype, "primaryColor", void 0), i([c({ type: String }), r("design:type", Object)], I.prototype, "accentColor", void 0), i([c({ type: Number }), r("design:type", Object)], I.prototype, "thickness", void 0), i([c({ type: Boolean }), r("design:type", Object)], I.prototype, "atomOrbit", void 0), i([c({ type: Boolean }), r("design:type", Object)], I.prototype, "paused", void 0), i([l("canvas"), r("design:type", typeof HTMLCanvasElement > "u" ? Object : HTMLCanvasElement)], I.prototype, "_canvas", void 0), I = i([s("ptc-ui-assistant-spinner")], I);
export { I as t };

//# sourceMappingURL=assistant-spinner-CfmqXlk1.js.map